"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourGrowthJourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="start-your-growth-journey" className="dark bg-background text-foreground relative py-24 sm:py-32 lg:py-40 overflow-hidden flex items-center justify-center min-h-[70vh]">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/70 via-background to-chart-3/70 opacity-90" />

      {}
      <div className="absolute inset-0 opacity-10 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/hexagon_pattern_generic.png')] bg-repeat mix-blend-overlay" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center max-w-4xl transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="text-4xl sm:text-5xl lg:text-7xl font-serif font-bold text-white mb-6 tracking-tight drop-shadow-lg">
          Start Your Growth Journey
        </h2>
        
        <p className="text-lg sm:text-2xl text-white/90 mb-12 max-w-3xl mx-auto font-sans font-light drop-shadow-md">
          Building relationships, not just businesses. Partner with RPG-Studios to elevate your digital presence and achieve lasting success.
        </p>

        {}
        <Button asChild size="lg" className="bg-white/20 hover:bg-white/30 backdrop-blur-2xl border border-white/40 text-primary-foreground font-bold rounded-full px-8 py-8 text-lg sm:text-xl transition-all duration-300 group shadow-[0_8px_32px_0_rgba(0,0,0,0.3)] hover:shadow-primary/20">
          <Link to="mailto:sales@rpg-studios.com">
            Book Your Consultation
            <ArrowRight className="ml-3 size-6 transition-transform group-hover:translate-x-2" />
          </Link>
        </Button>
      </div>
    </section>;
}